import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_HEART_PULSE: GlameraIconDefinition = {
  name: 'heart-pulse',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-heart-pulse-heart" d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
    <path class="glm-heart-pulse-line" d="M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-heart-pulse-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './heart-pulse.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HeartPulseIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_HEART_PULSE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
